module.exports = __webpack_public_path__ + "static/media/ex1.8e4a41d5.jpg";